const LinkButton = ({ children, ...props }) => (
  <button
    className="text-blue-600 underline mt-0.3 text-sm"
    type="button"
    {...props}
  >
    {children}
  </button>
)

export default LinkButton
